import React, { useState, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useOnClickOutside } from '../Helpers/useOnClickOutside';

export default function Header() {
	const { authenticated, signOut } = useAuth();
	const [
		isMenuOpen,
		setIsMenuOpen
	] = useState(false); // State for menu visibility
	const location = useLocation(); // Get current location
	const ref = useRef();

	const toggleMenu = () => {
		setIsMenuOpen((prevState) => !prevState);
	};

	// Close menu when clicking outside if the menu is open
	useOnClickOutside(ref, () => {
		if (isMenuOpen) setIsMenuOpen(false);
	});

	// Close the menu when a link is clicked
	const handleLinkClick = () => {
		setIsMenuOpen(false);
	};

	// Menu structure
	let menu = (
		<div className="z-0">
			{/* Menu container */}
			<div
				ref={ref}
				className="absolute bg-white border w-auto p-4 rounded-lg shadow-lg top-16 right-8"
			>
				<ul className="space-y-2">
					<li>
						<Link
							className="flex items-center p-2 hover:bg-gray-100 rounded text-md"
							to="/dashboard"
							onClick={handleLinkClick}
						>
							<i className="fa-solid fa-tachometer-alt text-lg mr-3" />
							Dashboard
						</Link>
					</li>
					<li>
						<Link
							className="flex items-center p-2 hover:bg-gray-100 rounded text-md"
							to="/users/1"
							onClick={handleLinkClick}
						>
							<i className="fa-solid fa-user text-lg mr-3" />
							User Profile
						</Link>
					</li>
					<li>
						<Link
							className="flex items-center p-2 hover:bg-gray-100 rounded text-md"
							to="/accounts/1"
							onClick={handleLinkClick}
						>
							<i className="fa-solid fa-briefcase text-lg mr-3" />
							Account Profile
						</Link>
					</li>
					<li>
						<Link
							className="flex items-center p-2 hover:bg-gray-100 rounded text-md"
							to="/signin"
							onClick={signOut}
						>
							<i className="fa-solid fa-sign-out-alt text-lg mr-3" />
							Sign Out
						</Link>
					</li>
				</ul>
			</div>
		</div>
	);

	return (
		<React.Fragment>
			<nav className="flex flex-wrap p-6 bg-tt-blue-900">
				{/* Logo and Title */}
				<div className="text-white">
					<Link to="/">
						<span className="text-3xl flex items-center tracking-wide font-medium font-rampart-one">
							<i className="fa fa-caravan text-white mr-2" />
							Travltax
						</span>
					</Link>
				</div>

				{/* Menu Items */}
				<div className="inline flex-grow lg:flex items-center lg:w-auto">
					<div className="text-lg lg:flex-grow">
						<div className="mr-5 md:mr-5">
							{/* Check if authenticated */}
							{authenticated ? (
								<div className="grid">
									<i
										className="fa fa-bars mt-2 md:mt-0 text-white md:text-2xl justify-self-end cursor-pointer relative"
										aria-hidden="true"
										onClick={toggleMenu}
									/>
									{isMenuOpen && menu}
								</div>
							) : (
								// Show Sign in link only if not on /signin page
								location.pathname !== '/signin' && (
									<div className="grid">
										<Link
											to="/signin"
											className="bg-white text-tt-blue-700 text-sm md:text-base mt-1 lg:mt-0 px-4 py-2 rounded-full shadow hover:shadow-md hover:bg-tt-blue-100 hover:underline transition-colors duration-200 flex items-center justify-self-end"
										>
											<span>Sign in</span>
										</Link>
									</div>
								)
							)}
						</div>
					</div>
				</div>
			</nav>
		</React.Fragment>
	);
}
